import t from "@ext/localization/locale/translate";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogIcon,
	AlertDialogTitle,
} from "@ui-kit/AlertDialog";
import { renderWithBranches } from "./BranchCheckoutText";

export const BranchCheckoutBlockedDialog = ({ branch, onClose }: { branch: string; onClose: () => void }) => (
	<AlertDialog onOpenChange={(open) => !open && onClose()} open>
		<AlertDialogContent>
			<AlertDialogHeader>
				<AlertDialogIcon icon="alert-circle" />
				<AlertDialogTitle>{t("git.checkout.blocked-title")}</AlertDialogTitle>
				<AlertDialogDescription className="space-y-2">
					<p>{renderWithBranches(t("git.checkout.blocked-description"), { branch })}</p>
					<p>{t("git.checkout.mode-description")}</p>
				</AlertDialogDescription>
			</AlertDialogHeader>
			<AlertDialogFooter>
				<AlertDialogAction onClick={onClose}>{t("close")}</AlertDialogAction>
			</AlertDialogFooter>
		</AlertDialogContent>
	</AlertDialog>
);
